<template>
</template>


<script>
	import * as turf from '@turf/turf';

	export default {
		name: 'ZoneLoader',
		computed: {
			drawLayer: {
				get() { return this.$store.state.map.drawLayer; }
			},
			stairs_vector: {
				get() { return this.$store.state.stairs_vector},
				set(value) {
					this.$store.commit('setState', ["stairs_vector", value]);
				}
			},
			layers: {
				get() { return this.$store.state.map.layers; },
			},
			zones: {
				get() { return this.$store.state.zones},
				set(value) {
					this.$store.commit('setState', ["zones", value]);
				}
			},
			zone_types() { return this.$config['zone_types']},
			features: {
				get() { return this.$store.state.features },
				set(value) { this.$store.commit('set_feature', value)}
			},
			map() { return this.$store.state.map.map },
			location() { return this.$store.state.location }
		},
		mounted() {
			this.init()
			this.load()
		},
		methods: {
			init() {
				this.stairs_vector = new ol.source.Vector();
			},
			load() {
				var format = new ol.format.GeoJSON();
				for (var i in this.zones) {
					let zone = this.zones[i];
					if (zone.vehicles === undefined) zone.vehicles = [];
					if (zone.tool == 'Circle') {
						let center = this.zones[i].center;
						let radius = this.zones[i].radius;

						var feature = new ol.Feature({
							geometry: new ol.geom.Circle(center, radius)
						});

						center = this.$geo.toTurf(center);
						let c1 = turf.point(center);
						let c2 = turf.point(this.$geo.toTurf(feature.getGeometry().getLastCoordinate()));

						radius = turf.distance(c1, c2);

						feature.turf = turf.circle(center, radius, { steps: 256});
						feature.inner = turf.circle(center, Math.min(radius, 0.02), { steps: 6});
						feature.center = this.$geo.toTurf(center);
					}
					else if (zone.tool == 'MultiLineString') {

						var feature = new ol.Feature({
							geometry: new ol.geom.MultiLineString(zone.coordinates)
						});

						var routes = [];

						for (let j in zone.coordinates) {
							let route = new ol.Feature({
								geometry: new ol.geom.LineString(zone.coordinates[j])
							});
							route.id = zone.id+'-'+j;
							routes.push(route)
						}

						feature.graph = new ol.source.Vector({
							features: routes
						});

						let coordinates = this.$geo.toTurf(zone.coordinates);
						// var line = turf.lineString(coordinates);
						// line = turf.buffer(line, 0.1, {units: 'kilometers'});
						feature.turf = turf.multiLineString(coordinates);
						feature.center = feature.turf.geometry.coordinates[0][0];
						feature.inner = turf.circle(feature.center, 0.02, {steps: 6});
					}
					else if (zone.tool == 'Point') {
						var feature = new ol.Feature({
							geometry: new ol.geom.Point(zone.coordinates)
						});
					}
					else {
						var feature = new ol.Feature({
							geometry: new ol.geom.Polygon(zone.coordinates),
						});

						let coordinates = this.$geo.toTurf(zone.coordinates[0]);

						feature.turf = turf.polygon([coordinates]);

						let center = turf.centerOfMass(feature.turf).geometry.coordinates;
						feature.inner = turf.circle(center, 0.02, { steps: 6});
						feature.center = center;
					}
					feature.id = zone.id;
					feature.floor_level = zone.floor_level;
					feature.type = zone.type;
					feature.tool = zone.tool;



					let inner = turf.intersect(feature.turf, feature.inner);
					if (inner) feature.inner = inner;
					/*if (feature.inner) {
						feature.inner = format.readFeature(feature.inner);
						feature.inner.getGeometry().transform('EPSG:4326', 'EPSG:3857');
						this.drawLayer.addFeature(feature.inner);
					}*/


					this.drawLayer.addFeature(feature);
					if (zone.type == 'stairs') this.stairs_vector.addFeature(feature);
					this.features[feature.id] = feature;

				}
			}
		}
	}
</script>
